import React from "react";

export default function CheckMarkv2({ width, height, ...props }) {
  return (
    <svg
      width={width ? width : "10"}
      height={height ? height : "10"}
      viewBox="0 0 13 16"
      fill="#FFFFFF"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M5.29484 14C4.85964 14 4.44804 13.7964 4.18344 13.4472L0.609843 8.72782C0.145043 8.11402 0.266043 7.24002 0.879843 6.77502C1.49464 6.30982 2.36804 6.43162 2.83304 7.04502L5.18344 10.1486L11.0948 0.657024C11.5018 0.00402431 12.3612 -0.195776 13.0156 0.210624C13.6692 0.617424 13.8688 1.47742 13.4616 2.13102L6.47844 13.343C6.23584 13.7328 5.81704 13.978 5.35844 13.9988C5.33704 13.9996 5.31604 14 5.29484 14Z" />
    </svg>
  );
}
